import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './index.css';
import './i18n';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './components/ui';
import { installMockEnvIfRequested, startMockRealtimeDriver } from './lib/mock';
import { ThemeProvider } from './lib/theme';
import { tg } from './lib/tg';

// `?mock=1` installs a stub Telegram WebApp + fixture API responses so
// the app boots in a regular browser without a real bot session. Must
// run before `tg.ready()` so the lazy `tg` lookups see the stub.
installMockEnvIfRequested();
// Drive a fake price stream in mock mode so the dashboard's PriceToBeat
// block animates in dev without a real trading_engine. No-op in prod.
startMockRealtimeDriver();

// Initialize Telegram WebApp (noop outside TG)
tg.ready();
tg.expand();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
